/**
 * @generated SignedSource<<89063032561369508d96aea0af5ff8e1>>
 * @relayHash 9659ce97ef8ff267228c6339bb685d14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6d8b9d4ddb68ba2ed58fcfd8525e3fb368eff05bcbfadfcb924ba07588a969a6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { profileMenuQuery } from './profileMenuQuery.graphql';

const node: PreloadableConcreteRequest<profileMenuQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6d8b9d4ddb68ba2ed58fcfd8525e3fb368eff05bcbfadfcb924ba07588a969a6",
    "metadata": {},
    "name": "profileMenuQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
